import { Flex } from "@chakra-ui/layout";
import { Heading } from "@chakra-ui/react";
import { Modal } from "antd";
import useFindContaComplete from "core/features/conta/hooks/useFindContaComplete";
import { OperacaoEnum } from "core/resources/enums/conta";
import ContentDetalhesConta from "ui/components/ContentDetalheConta/index";
import { useLoading } from "ui/components/GlobalLoading";
import PrimaryButton from "components/Button/PrimaryButton";

interface ModalContentContaProps {
  contaId?: string;
  isOpenModal: boolean;
  onClose: () => any;
}

export function ModalContentConta({
  contaId,
  isOpenModal,
  onClose,
}: ModalContentContaProps) {
  const { data, isLoading } = useFindContaComplete(contaId);

  useLoading(isLoading);

  return (
    <>
      <Modal
        centered
        destroyOnClose
        width="1000px"
        footer={
          <Flex flex={1} justifyContent="end" gap={4}>
            <PrimaryButton onClick={onClose}>Fechar</PrimaryButton>
          </Flex>
        }
        visible={isOpenModal}
        onCancel={onClose}
      >
        <Flex>
          <Heading mb={4} size="md">
            {data?.operacao === OperacaoEnum.Despesa ? "Despesas" : "Receitas"}
          </Heading>
        </Flex>

        {data ? <ContentDetalhesConta data={data} operacao={data.operacao} /> : null}
      </Modal>
    </>
  );
}
